module.exports = __webpack_public_path__ + "static/media/Pic2.1f1878f1.png";